import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IOperative } from "../../../message-models/operative.interface";
import { ICompanyEngagementHistory } from "../../../message-models/company-engagement-history.interface";
import { IJobTitleInfo } from "../../../message-models/job-title.interface";
import { IRiskInfo } from "../../../message-models/risk-info.interface";
import { IJobLevelInfo } from "../../../message-models/job-level.interface";
import { CompanyEngagementHistory } from "../../../message-models/company-engagement-history.class";
import { IEmploymentStatus } from '../../../message-models/employment-status.interface';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { IOperativeTypeInfo } from '../../../message-models/operative-type.interface';
import { IBusinessUnitInfo } from '../../../message-models/business-unit.interface';
import { ICompanyJobTitle } from '../../../message-models/company-job-title.interface';

@Component({
  selector: 'app-engagement-history-modal',
  templateUrl: './engagement-history-modal.component.html',
  styleUrls: ['./engagement-history-modal.component.scss']
})
export class EngagementHistoryModalComponent implements OnInit {
  @Input() heading: string = "Company Role Editor";
  @Input() editing: boolean = false;
  @Input() engagement: ICompanyEngagementHistory;

  @Input() allJobTitles: IJobTitleInfo[] = [];
  @Input() allCompanyJobTitles: ICompanyJobTitle[] = [];
  @Input() allRisks: IRiskInfo[] = [];
  @Input() allJobLevels: IJobLevelInfo[] = [];
  @Input() allOperativeTypes: IOperativeTypeInfo[] = [];
  @Input() allBusinessUnits: IBusinessUnitInfo[] = [];
  @Input() allEmploymentStatuses: IEmploymentStatus[] = [];

  @Input() operative: IOperative;
  saveAttempted: boolean = false;

  @Output() saveEngagementClicked: EventEmitter<ICompanyEngagementHistory> = new EventEmitter<ICompanyEngagementHistory>();
  @Output() cancelEngagementClicked: EventEmitter<any> = new EventEmitter<any>();
  showingHelp: boolean = false;

  constructor(public config: DynamicDialogConfig) { }

  ngOnInit(): void {
    if (this.config.data) {
      this.heading = this.config.data.heading;
      this.allJobTitles = this.config.data.allJobTitles;
      this.allCompanyJobTitles = this.config.data.allCompanyJobTitles;
      this.allJobLevels = this.config.data.allJobLevels;
      this.allRisks = this.config.data.allRisks;
      this.allOperativeTypes = this.config.data.allOperativeTypes;
      this.allBusinessUnits = this.config.data.allBusinessUnits;
      this.allEmploymentStatuses = this.config.data.allEmploymentStatuses;
      this.editing = this.config.data.editing;
      this.engagement = this.config.data.engagement;
    };
  }

  cancelClicked() {
    this.editing = false;
    this.cancelEngagementClicked.emit();
  }

  editEngagement() {
    this.editing = true;
  }

  saveEngagement() {
    this.saveAttempted = true;

    let engagement = new CompanyEngagementHistory(this.engagement);
    if (!engagement.isValid)
      return;

    this.saveEngagementClicked.emit(this.engagement);
    this.editing = false;
  }

  helpClicked() {
    this.showingHelp = !this.showingHelp;
  }
}
